
export type ComparisonOperator = 'Equal' |'NotEqual' | 'GreaterThan' | 'GreaterThanOrEqual' | 'LessThan' | 'LessThanOrEqual' | 'Contains' | 'StartsWith' | 'EndsWith' | 'InArray';
export type LogicalOperator = 'And' | 'Or' | 'Not';
export enum LogicalOperators {
    And = 'And',
    Or = 'Or',
    Not = 'Not'
}

export enum TypeFilterObject { Field = 'field', And = 'And', Or = 'Or', date = 'date' }

export enum ComparisonOperators{
    Equal = 'Equal',
    NotEqual = 'NotEqual',
    GreaterThan = 'GreaterThan',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
    LessThan = 'LessThan',
    LessThanOrEqual = 'LessThanOrEqual',
    Contains = 'Contains',
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    InArray = 'InArray',
}